import React from 'react';
import { formatDistance } from 'date-fns';
import { Image } from '../../../../wag-react/next-components/image';
import { WalkerReviewItem } from '../../../../types/api';
import photoPlaceholder from '../../../../assets/illustrations/pcg-photo-placeholder.svg';
import StarIcon from '../../../../assets/icons/walker-profile/assets/star.svg';
import { capitalizeFirstLetter } from '../../../OvernightServicePreferencesContainer/helpers';
import { serviceAssetMap } from '../WalkerServices/assets';
import { Box, BoxProps } from '../../../../wag-react/next-components/box';
import { Typography } from '../../../../wag-react/components/Typography';
const checkServiceType = (serviceType: string) => {
  let isWalkService = false;
  if (!serviceType) {
    isWalkService = true;
  }
  if (serviceType === 'walk' || serviceType === 'walk_deluxe' || serviceType === 'walk_express') {
    isWalkService = true;
  }
  return isWalkService;
};
type Props = {
  review: WalkerReviewItem;
  containerProps?: BoxProps;
};
const isVerified = true;
export const WalkerServiceReview = ({
  review,
  containerProps
}: Props) => <Box {...containerProps} data-sentry-element="Box" data-sentry-component="WalkerServiceReview" data-sentry-source-file="WalkerServiceReview.tsx">
    <Box display="flex" justifyContent="space-between" data-sentry-element="Box" data-sentry-source-file="WalkerServiceReview.tsx">
      <Box display="flex" alignItems="center" data-sentry-element="Box" data-sentry-source-file="WalkerServiceReview.tsx">
        <Image src={review.photo || photoPlaceholder} width="40px" height="40px" borderRadius="100%" alt="Profile photo" data-sentry-element="Image" data-sentry-source-file="WalkerServiceReview.tsx" />
        <Box ml="8px" data-sentry-element="Box" data-sentry-source-file="WalkerServiceReview.tsx">
          <Box display="flex" alignItems="baseline" mb="1px" data-sentry-element="Box" data-sentry-source-file="WalkerServiceReview.tsx">
            <Typography color="#272727" fontFamily="muliSemiBold" variant="body1" fontSize="16px" m={0} data-sentry-element="Typography" data-sentry-source-file="WalkerServiceReview.tsx">
              {review.firstName}
            </Typography>
            {isVerified && <Typography bg="#EEEEEE" py="2px" px="8px" borderRadius="4px" color="#818181" fontFamily="muliSemiBold" fontSize="12px" variant="legal" m={0} ml={2}>
                Verified
              </Typography>}
          </Box>
          <Typography color="#818181" fontFamily="muli" fontSize="12px" m={0} data-sentry-element="Typography" data-sentry-source-file="WalkerServiceReview.tsx">
            {formatDistance(new Date(review.createdAt), new Date())}
            {' '}
            ago
          </Typography>
        </Box>
      </Box>

      <Box display="flex" alignItems="center" data-sentry-element="Box" data-sentry-source-file="WalkerServiceReview.tsx">
        {Array.from(Array(Math.floor(review.rating)).keys()).map(key => <Image key={key} src={StarIcon} width="16px" height="16px" mr="4px" alt="Star icon" />)}
      </Box>
    </Box>

    <Typography color="#272727" fontFamily="muli" my="12px" fontSize="14px" data-sentry-element="Typography" data-sentry-source-file="WalkerServiceReview.tsx">
      {review.content}
    </Typography>

    <Box data-sentry-element="Box" data-sentry-source-file="WalkerServiceReview.tsx">
      <Box display="flex" alignItems="center" p={1} borderRadius="6px" mt={[1, 2]} bg="#EEEEEE" width="fit-content" data-sentry-element="Box" data-sentry-source-file="WalkerServiceReview.tsx">
        <Box width="16px" height="16px" mr="2px" data-sentry-element="Box" data-sentry-source-file="WalkerServiceReview.tsx">
          <Image width={checkServiceType(review.serviceType) ? '10px' : '16px'} height={checkServiceType(review.serviceType) ? '14px' : '16px'}
        /* Older reviews are missing service Types thats why we have the walk fallback */ src={serviceAssetMap[(review.serviceType || 'walk').replace('-', '_')].icon} alt="Service icon" data-sentry-element="Image" data-sentry-source-file="WalkerServiceReview.tsx" />
        </Box>
        <Typography m={0} color="#272727" fontFamily="muliSemiBold" fontSize="12px" data-sentry-element="Typography" data-sentry-source-file="WalkerServiceReview.tsx">
          {/* Older reviews are missing service Types thats why we have the walk fallback */}
          {capitalizeFirstLetter(serviceAssetMap[review.serviceType || 'walk'].title)}
        </Typography>
      </Box>
    </Box>
  </Box>;